export default __webpack_public_path__ + "static/media/65393.7f7502b4.jpg";